import * as Styles from "./SideMenuStyles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  updateActiveId,
  updateSubMenuActiveId,
  setCollapse,
} from "../../slices/SideMenu/SideMenuSlices";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import sideMenuItems from "../../Configs/SideMenuItems";
import { IType } from "../PPAndTCModal/Constant";
import PPAndTCModal from "../PPAndTCModal/PPAndTCModal";
import { auth } from "../../API/Auth";
import { tenant as tenantAPI } from "../../API/UserManagement/Tenant";
import { handleSessionUpdate } from "../../slices/Session/Session";
interface ITCAndPPModal {
  visibility: boolean;
  type: IType;
}

function SideMenu() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { activeId, subMenuActiveIds, collapse } = useAppSelector(
    (store) => store.sideMenu
  );
  const selectedTenant = useAppSelector((state) => state.session.selectedTenant);

  const [TCAndPPModalProps, setTCAndPPModalProps] = useState<ITCAndPPModal>({
    visibility: false,
    type: "PP",
  });
  const handleTCAndPPClicks = (type: "TC" | "PP") => {
    setTCAndPPModalProps((pre: ITCAndPPModal) => {
      return {
        ...pre,
        type: type,
        visibility: true,
      };
    });
  };

  const dataEntryMode = (selectedTenant as any)?.configs?.dataEntryMode || "Hybrid";

  useEffect(() => {
    const fetchTenantConfig = async () => {
      const currentWorkspace = auth.getCurrentWorkspace() as any;
      const tenantId = currentWorkspace?.id;
      if (!tenantId) return;

      // If Redux already has the config, we don't strictly need to fetch it again,
      // but doing it once on mount or when tenantId changes ensures consistency.
      const res = await tenantAPI.getTenant(tenantId);

      // Robustly extract the tenant object and its configs
      const tenantData = res?.data?.[0]?.org || res?.data?.[0]?.orgs || res?.data || res;
      const mode = tenantData?.configs?.dataEntryMode;

      if (mode && (selectedTenant as any)?.configs?.dataEntryMode !== mode) {
        // Update Redux state to trigger UI updates across the app
        dispatch(handleSessionUpdate({
          selectedTenant: {
            ...(selectedTenant || {}),
            ...tenantData
          }
        }));
      }
    };
    
    fetchTenantConfig();
  }, [selectedTenant?.id]);
  useEffect(() => {
    const pathname = location.pathname;
    let activeMenuItem, activeSubMenuItem;

    let sMenuItem = [...sideMenuItems];

    sMenuItem = sMenuItem.filter((item: any) => {
      // const isSuperAdmin = auth.getUsersPrivileges().includes("20");
      // if (isSuperAdmin && item.url === "/notifications") return false;

      if (item.privileges && item.privileges.length > 0) {
        return item.privileges.some((privilege: any) =>
          auth.getUsersPrivileges().includes(privilege)
        );
      }
      return true;
    });

    sMenuItem.forEach((menuItem: any) => {
      if (menuItem?.url === pathname) {
        activeMenuItem = menuItem?.key;
      } else if (menuItem?.subItems) {
        menuItem?.subItems.forEach((subMenuItem: any) => {
          if (subMenuItem?.url === pathname) {
            activeMenuItem = subMenuItem.key;
            activeSubMenuItem = [menuItem?.key];
          }
        });
      }
    });
    activeMenuItem && dispatch(updateActiveId(activeMenuItem));
    activeSubMenuItem && dispatch(updateSubMenuActiveId(activeSubMenuItem));
  }, [location.pathname]);

  function handlemenuActiveChange(item: any) {
    dispatch(updateActiveId(item.key));
  }

  function handleSubMenuActiveChange(item: any) {
    dispatch(updateSubMenuActiveId(item));
  }

  const toggleCollapsed = () => {
    dispatch(setCollapse(!collapse));
  };

  const renderSubItems = (subItems: any[]) => {
    return subItems.map((subItem) => {
      if (subItem.subItems) {
        const filteredSubItems = subItem.subItems.filter((item: any) => {
          if (item.privileges && item.privileges.length > 0) {
            return item.privileges.some((privilege: any) =>
              auth.getUsersPrivileges().includes(privilege)
            );
          }
          return true;
        });

        if (filteredSubItems.length > 0) {
          return (
            <SubMenu
              key={subItem.key}
              icon={subItem.Icon}
              title={subItem.title}
            >
              {renderSubItems(filteredSubItems)}
            </SubMenu>
          );
        }
      } else {
        if (
          !subItem.privileges ||
          subItem.privileges.some((privilege: any) =>
            auth.getUsersPrivileges().includes(privilege)
          )
        ) {
          return (
            <Menu.Item key={subItem.key}>
              <Link to={subItem.url || ""}>{subItem.title}</Link>
            </Menu.Item>
          );
        }
      }
      return null;
    });
  };

  return (
    <Styles.Container>
      {collapse ? (
        <RightCircleOutlined className="toggleBtn" onClick={toggleCollapsed} />
      ) : (
        <LeftCircleOutlined className="toggleBtn" onClick={toggleCollapsed} />
      )}
      <PPAndTCModal
        visibility={TCAndPPModalProps.visibility}
        setVisibility={setTCAndPPModalProps}
        type={TCAndPPModalProps.type}
      />
      <Menu
        className="menu"
        style={{ transitionDelay: "-0.9s" }}
        selectedKeys={[activeId]}
        mode="inline"
        onClick={(item) => handlemenuActiveChange(item)}
        openKeys={subMenuActiveIds}
        onOpenChange={(openKeys: string[]) =>
          handleSubMenuActiveChange(openKeys)
        }
        inlineCollapsed={collapse}
      >
        {collapse ? (
          <RightCircleOutlined
            className="toggleBtn"
            onClick={toggleCollapsed}
          />
        ) : (
          <LeftCircleOutlined className="toggleBtn" onClick={toggleCollapsed} />
        )}

        {sideMenuItems.map((item: any) => {
          // Hide the Notifications inbox for a SUPER_ADMIN (type 20) UNLESS the
          // user also genuinely holds a Notifications privilege ("5"/"6").
          // SUPER_ADMIN inherits "5"/"6" implicitly, so check assigned privileges.
          if (
            item.url === "/notifications" &&
            auth.getUsersPrivileges().includes("20") &&
            !["5", "6"].some((p) => auth.getAssignedPrivileges().includes(p))
          ) {
            return null;
          }

          // Filtering subtabs of "Libraries" (key: "sub-2") based on dataEntryMode
          if (item.key === "sub-2" && item.subItems) {
            const modeFilteredSubItems = item.subItems
              .filter((subItem: any) => {
                if (dataEntryMode === "Manual") {
                  // Manual Mode: Sponsor (8), User roles (9) and Contact Library (11) (shown as "User")
                  return ["8", "9", "11"].includes(subItem.key);
                } else {
                  // Centralized/Hybrid Mode: Sponsor (8), User roles (9), Contacts (11), Study (12) and Products (sub-3)
                  return ["8", "9", "11", "12", "sub-3"].includes(subItem.key);
                }
              })
              .map((subItem: any) => {
                // In Manual mode, "Contact Library" is renamed to "User"
                if (dataEntryMode === "Manual" && subItem.key === "11") {
                  return { ...subItem, title: "User" };
                }
                return subItem;
              });
            item = { ...item, subItems: modeFilteredSubItems };
          }

          if (item.subItems) {
            const filteredSubItems = item.subItems.filter((subItem: any) => {
              if (subItem.privileges && subItem.privileges.length > 0) {
                return subItem.privileges.some((privilege: any) =>
                  auth.getUsersPrivileges().includes(privilege)
                );
              }
              return true;
            });

            if (filteredSubItems.length > 0) {
              return (
                <SubMenu key={item.key} icon={item.Icon} title={item.title}>
                  {renderSubItems(filteredSubItems)}
                </SubMenu>
              );
            }
          } else {
            if (
              !item.privileges ||
              item.privileges.some((privilege: any) =>
                auth.getUsersPrivileges().includes(privilege)
              )
            ) {
              return (
                <Menu.Item key={item.key} icon={item.Icon}>
                  <Link to={item.url || ""}>{item.title}</Link>
                </Menu.Item>
              );
            }
          }
          return null;
        })}
      </Menu>
      {!collapse && (
        <Styles.MenuFooter>
          <h5>
            Product by <span>Soterius</span>
          </h5>

          <h5>Version 4.0.0</h5>

          <Styles.FooterLinks>
            <Link
              to=""
              onClick={() => {
                handleTCAndPPClicks("TC");
              }}
            >
              <h5> Terms & Conditions</h5>
            </Link>
            <span style={{ margin: "0 5px" }}>|</span>
            <Link
              to=""
              onClick={() => {
                handleTCAndPPClicks("PP");
              }}
            >
              <h5> Privacy Policy</h5>
            </Link>
          </Styles.FooterLinks>
        </Styles.MenuFooter>
      )}
    </Styles.Container>
  );
}

export default SideMenu;
